module.exports = __webpack_public_path__ + "img/profileIcon.aab57746.svg";